module.exports = __webpack_public_path__ + "static/media/sprintbot3.4e56871a.png";